
import api from "../api";

const controller = 'crfContratos';

export interface ITaskBackgroundCrf {
    codigoTask: number;
    descricaoTask: string;
    emProcessamento: boolean
    descricaoFalha: string;
    inicioProcessamento: Date;
    finalProcessamento: Date;
    status: string;
    numeroLinha: number;
}


export const getAllTaskBackgroundCrf = () => {
    return api.get<ITaskBackgroundCrf[]>(`crfTaskBackground/getAll`);
}


